module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level"
  }, [_c('p', {
    staticClass: "level__title"
  }, [_vm._v(_vm._s(_vm.text))]), (_vm.value !== '') ? _c('Progress', {
    attrs: {
      "value": _vm.value
    }
  }) : _c('div', {
    staticClass: "level__empty"
  }, [_vm._v("???")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-293068ec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/SmartStatItem.vue
// module id = 6ed66c1283c02d8df939
// module chunks = 89